import { CLEAR_WRITE, WRITE_NEWS } from '../actions/types';

const INITIAL_STATE = { title: '', text: '' };

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WRITE_NEWS:
      return { ...state, [action.target]: action.payload };
    case CLEAR_WRITE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
